import { Grid2 } from '@mui/material';
import { Formik, type FormikHelpers, type FormikProps } from 'formik';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Container, Heading } from '../components';
import { AuthService, EmailService, useContactFormValues } from '../services';
import { contact } from '../text';
import type { IContactValues } from '../types';
import { ContactDialogMenu } from './contact/ContactDialogMenu';
import { ContactForm, contactSchema } from './contact/ContactForm';

const Child = styled((props: any) => <Grid2 {...props} />)`
	& + & {
		flex-basis: auto;
		margin-top: 24px;
		justify-content: center;
	}
`;

export const Contact = () => {
	const initialValues = {
		subject: '',
		message: '',
		firstName: '',
		lastName: '',
		phoneNumber: '',
		emailAddress: '',
		confirmEmailAddress: '',
	};
	const navigate = useNavigate();
	const [tokenV2, setTokenV2] = useState('');
    const { contactForm } = useContactFormValues(initialValues);
	const [open, setOpen] = useState(false);
	const [repCode, setRepCode] = useState(-1);
	return (
		<Container container>
            <Child>
				<Heading title={contact.title} subtitle={contact.subtitle} />
			</Child>
            <Child container>
                <Formik
					initialValues={AuthService.isAuth().val ? contactForm.data : initialValues}
					validationSchema={contactSchema}
					onSubmit={(v: IContactValues, a: FormikHelpers<IContactValues>) => {
						EmailService.sendContactEmail(
							v.subject,
							v.message,
							v.firstName,
							v.lastName,
							v.phoneNumber,
							v.emailAddress,
							tokenV2
						).then(
							res => {
								setRepCode(res);
								setOpen(true);
								a.resetForm();
								navigate('/');
							},
							err => {
								setRepCode(err);
								setOpen(true);
							}
						);
					}}
				>
					{(props: FormikProps<IContactValues>) => (
						<ContactForm onV2={(token: string) => setTokenV2(token)} {...props} />
					)}
				</Formik>
			</Child>
			<ContactDialogMenu open={open} setOpen={setOpen} statusCode={repCode} />
		</Container>
	);
};
